export default __webpack_public_path__ + "img/fDjudVXs.36e8ea53.svg";